<template>
    <div class="role_user">
        <div class="allData large">
            <h3>{{$t('message.UnassignedUser')}}</h3>
            <el-form :model="searchFormNot" class="searchRoleForm" inline ref="searchFormNot">
                <el-form-item prop="NoPsermissionContent">
                    <el-input clearable placeholder=" "
                              v-model="searchFormNot.NoPsermissionContent"></el-input>
                </el-form-item>
                <el-form-item style="margin-right: 0;">
                    <el-tooltip :content="$t('message.Search')" class="item" effect="dark" placement="top">
                        <el-button @click="searchUserNot('searchFormNot')"
                                   class="icon iconfont icon-sousuo" type="primary">
                        </el-button>
                    </el-tooltip>
                </el-form-item>
            </el-form>
            <el-table
                    :data="userTableData"
                    :header-cell-style="{'background-color': '#f8f8f9'}"
                    @selection-change="userNotSelection"
                    class="table_border border-top"
                    height="322"
                    ref="userNotSearch"
                    stripe
                    v-loading="loading1">
                <el-table-column
                        type="selection">
                </el-table-column>
                <el-table-column
                        :label="$t('message.SAPCode')"
                        prop="SAPCode">
                </el-table-column>
                <el-table-column
                        :label="$t('message.UserName')"
                        prop="ChineseName">
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                        :current-page.sync="currentPage1"
                        :page-size="pageSize1"
                        :total="maxpage1"
                        @current-change="handleCurrentChange1"
                        background
                        class="pagination"
                        layout="prev, pager, next">
                </el-pagination>
            </div>
        </div>
        <div class="dataBtns">
            <el-tooltip :content="$t('message.AddTo')" class="item" effect="dark" placement="top">
                <el-button :disabled="canAdd" @click="addUsers" circle icon="el-icon-arrow-right"></el-button>
            </el-tooltip>
            <el-tooltip :content="$t('message.Remove')" class="item" effect="dark" placement="top">
                <el-button :disabled="canDel" @click="delUsers" circle icon="el-icon-arrow-left"></el-button>
            </el-tooltip>
        </div>
        <div class="checkedData large">
            <h3>{{$t('message.AssignedUser')}}</h3>
            <el-form :model="searchForm" class="searchRoleForm" inline ref="searchForm">
                <el-form-item prop="PsermissionContent">
                    <el-input clearable placeholder=" "
                              v-model="searchForm.PsermissionContent"></el-input>
                </el-form-item>
                <el-form-item style="margin-right: 0;">
                    <el-tooltip :content="$t('message.Search')" class="item" effect="dark" placement="top">
                        <el-button @click="searchUser('searchForm')"
                                   class="icon iconfont icon-sousuo" type="primary">
                        </el-button>
                    </el-tooltip>
                </el-form-item>
            </el-form>
            <el-table
                    :data="userData"
                    :header-cell-style="{'background-color': '#f8f8f9'}"
                    :row-key="row => row.index"
                    @selection-change="userSelection"
                    class="table_border border-top"
                    height="322"
                    ref="userSearched"
                    stripe
                    v-loading="loading2">
                <el-table-column
                        type="selection">
                </el-table-column>
                <el-table-column
                        :label="$t('message.SAPCode')"
                        prop="SAPCode">
                </el-table-column>
                <el-table-column
                        :label="$t('message.UserName')"
                        prop="ChineseName">
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                        :current-page.sync="currentPage2"
                        :page-size="pageSize2" :total="maxpage2"
                        @current-change="handleCurrentChange2"
                        background
                        class="pagination"
                        layout="prev, pager, next">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {getLocal} from "../config/mUtils";
    import {GetRoleUsers, SetRoleUsers} from "../api/apiRole";

    export default {
        name: 'userAssign',
        data() {
            return {
                loading1: false,
                loading2: false,
                searchFormNot: {
                    NoPsermissionContent: ''
                },
                searchForm: {
                    PsermissionContent: ''
                },
                userData: [],
                userTableData: [],
                currentPage1: 1,
                pageSize1: 50,
                maxpage1: 0,
                currentPage2: 1,
                pageSize2: 50,
                maxpage2: 0,
                pageStart1: 0,
                pageStart2: 0,
                pageEnd1: 0,
                pageEnd2: 0,
                userSelections: [],
                userNotSelections: [],
                canAdd: true,
                canDel: true,
            };
        },
        created() {
            this.getUserDataNo();
            this.getUserData();
        },
        computed: {},
        components: {},
        props: ['RoleId'],
        watch: {},
        methods: {
            // 更改当前页数
            handleCurrentChange1(val) {
                this.currentPage1 = val;
                this.getUserDataNo();
            },
            // 更改当前页数
            handleCurrentChange2(val) {
                this.currentPage2 = val;
                this.getUserData();
            },
            // 控制添加按钮
            userNotSelection(val) {
                this.userNotSelections = val;
                if (val.length > 0) {
                    this.canAdd = false;
                } else {
                    this.canAdd = true;
                }
            },
            // 控制取消按钮
            userSelection(val) {
                this.userSelections = val;
                if (val.length > 0) {
                    this.canDel = false;
                } else {
                    this.canDel = true;
                }
            },
            // 获取未选择人员数据
            async getUserDataNo() {
                this.loading1 = true;
                const crs = await GetRoleUsers(
                    this.RoleId,
                    this.searchFormNot.NoPsermissionContent,
                    this.currentPage1,
                    this.pageSize1,
                    '',
                    this.currentPage2,
                    this.pageSize2,
                    getLocal('language')
                );
                this.userTableData = [];
                if (crs.error_code === '0') {
                    this.loading1 = false;
                    this.maxpage1 = crs.data.noPermissionCount;
                    this.userTableData = crs.data.noPermission;
                }
            },
            // 获取已选择人员数据
            async getUserData() {
                this.loading2 = true;
                const crs = await GetRoleUsers(
                    this.RoleId,
                    '',
                    this.currentPage1,
                    this.pageSize1,
                    this.searchForm.PsermissionContent,
                    this.currentPage2,
                    this.pageSize2,
                    getLocal('language')
                );
                this.userData = [];
                if (crs.error_code === '0') {
                    this.loading2 = false;
                    this.maxpage2 = crs.data.havePermissionCount;
                    this.userData = crs.data.havePermission;
                }
            },
            // 搜索未选择人员数据
            searchUserNot() {
                this.currentPage1 = 1;
                this.getUserDataNo();
            },
            // 搜索已选择人员数据
            searchUser() {
                this.currentPage2 = 1;
                this.getUserData();
            },
            // 保存选择
            async saveUsers() {
                let idlists = [];
                this.userNotSelections.forEach(item => {
                    let msg = item.UserId;
                    idlists.push(msg);
                });
                const crs = await SetRoleUsers(
                    this.RoleId,
                    idlists,
                    1
                );
                if (crs.error_code === '0') {
                    this.$refs.userNotSearch.clearSelection();
                    this.$refs.userSearched.clearSelection();
                    this.userNotSelections = [];
                    this.userSelections = [];
                    this.currentPage1 = 1;
                    this.currentPage2 = 1;
                    this.canAdd = true;
                    this.getUserDataNo();
                    this.getUserData();
                }
            },
            // 添加
            addUsers() {
                this.saveUsers();
            },
            // 删除选择
            async userDelete() {
                let idlists = [];
                this.userSelections.forEach(item => {
                    let msg = item.UserId;
                    idlists.push(msg);
                });
                const crs = await SetRoleUsers(
                    this.RoleId,
                    idlists,
                    2
                );
                if (crs.error_code === '0') {
                    this.$refs.userNotSearch.clearSelection();
                    this.$refs.userSearched.clearSelection();
                    this.userNotSelections = [];
                    this.userSelections = [];
                    this.currentPage1 = 1;
                    this.currentPage2 = 1;
                    this.canAdd = true;
                    this.getUserDataNo();
                    this.getUserData();
                }
            },
            // 去除
            delUsers() {
                this.userDelete();
            },
        }
    };
</script>

<style scoped>

</style>
